<div>
    <h2 class="uo-contact" translate>adminUpdateOrg.updateOrganization</h2>
    <popup-loader *ngIf="!isLoaded"></popup-loader>
    <div *ngIf="isLoaded" class="setting-orgadmin">
        <div class="basic-info">
            <h5 class="center" translate>adminUpdateOrg.basicInformation</h5>
            <div class="app-l-form-wrapper">
                <div class="app-c-form-group drp-down">
                    <label id="organization-select-label" class="app-c-form--label" translate>adminUpdateOrg.selectACampus</label>
                    <!-- <select
                        class="app-c-form-control"
                        [(ngModel)]="organization"
                        (ngModelChange)="onChangeOrg($event)">
                        <option *ngFor="let org of organizations" [value]="org">{{ org.name }}</option>
                    </select> -->

                     <div class="app-c-custom-select" [class.is-open]="isOrgOpen">
                        <div
                            class="app-c-select-trigger app-c-form-control"
                            role="combobox"
                            aria-haspopup="listbox"
                            aria-autocomplete="none"
                            aria-labelledby="organization-select-label"
                            aria-controls="organization-options"
                            [attr.aria-expanded]="isOrgOpen"
                            tabindex="0"
                            (click)="isOrgOpen = !isOrgOpen"
                            (keydown.enter)="isOrgOpen = !isOrgOpen"
                            (keydown.space)="$event.preventDefault(); isOrgOpen = !isOrgOpen"
                            (keydown.escape)="isOrgOpen = false">
                        <span>{{ organization?.name || 'Select' }}</span>
                        </div>

                        <ul id="organization-options" class="app-c-select-list" *ngIf="isOrgOpen" role="listbox" aria-labelledby="organization-select-label">
                        <li *ngFor="let org of organizations"
                            role="option"
                            tabindex="0"
                            [class.is-selected]="organization?.name === org.name"
                            [attr.aria-selected]="organization?.id === org.id"
                            (click)="organization = org; isOrgOpen = false; onChangeOrg(org)"
                            (keydown.enter)="organization = org; isOrgOpen = false; onChangeOrg(org)"
                            (keydown.space)="$event.preventDefault(); organization = org; isOrgOpen = false; onChangeOrg(org)">
                            {{ org.name }}
                        </li>
                        </ul>
                    </div>
                </div>
                <div class="app-c-form-group">
                    <label class="app-c-form--label" translate>adminUpdateOrg.organizationName</label>
                    <input
                        class="app-c-form-control field-disabled"
                        aria-label="Full Name"
                        tabindex="0"
                        readonly
                        id="fullname"
                        type="text"
                        name="fullName"
                        [(ngModel)]="orgName" />
                </div>
                <form
                    #f="ngForm"
                    class="org-edit-form"
                    [formGroup]="orgEditForm">
                    <div>
                        <label translate>adminUpdateOrg.address</label>
                        <input
                            #search
                            [placeholder]="'Type your address...'"
                            type="text"
                            formControlName="address" />
                        <div id="addressSuggestions"></div>
                    </div>
                    <div appearance="outline">
                        <label translate>adminUpdateOrg.phoneNumber</label>
                        <!-- <ngx-intl-tel-input
                            [cssClass]="'custom'"
                            placeholder="Enter Number"
                            formControlName="phone"
                            [preferredCountries]="preferredCountries"
                            [enableAutoCountrySelect]="true"
                            [enablePlaceholder]="true"
                            [enableSearch]="true"
                            name="phone"
                            #phoneInput>
                        </ngx-intl-tel-input> -->
                        <ngx-intl-tel-input
                            [preferredCountries]="preferredCountries"
                            [enableAutoCountrySelect]="true"
                            [searchCountryFlag]="true"
                            [enablePlaceholder]="true"
                            [searchCountryFlag]="true"
                            [searchCountryField]="[
                                SearchCountryField.Iso2,
                                SearchCountryField.Name,
                            ]"
                            placeholder="Enter Number"
                            [selectFirstCountry]="false"
                            [selectedCountryISO]="CountryISO.India"
                            [maxLength]="15"
                            [phoneValidation]="true"
                            [separateDialCode]="separateDialCode"
                            [numberFormat]="PhoneNumberFormat.National"
                            formControlName="phone">
                        </ngx-intl-tel-input>
                        <!-- <mat-hint class="field-hint" translate
                            ><span translate> adminUpdateOrg.eg</span>:
                            {{
                                phoneInput.selectedCountry?.placeHolder
                            }}</mat-hint
                        > -->
                        <div
                            class="error-message"
                            *ngIf="orgEditForm.controls['phone'].touched && orgEditForm.controls['phone'].errors?.validatePhoneNumber"
                            translate>adminUpdateOrg.invalidNumber</div>
                    </div>

                    <div class="app-c-form-group">
                        <label class="app-c-form--label" translate>adminUpdateOrg.website</label>
                        <input
                            class="app-c-form-control"
                            aria-label="Website"
                            formControlName="website"
                            tabindex="0"
                            type="text" />
                        <div
                            class="error-message"
                            *ngIf="orgEditForm.controls['website'].touched && !orgEditForm.controls['website'].valid"
                            translate>
                            adminUpdateOrg.invalidUrl
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="emergency-contact">
            <h3 translate>adminUpdateOrg.emergencyContactMessage</h3>
            <div class="emergency-body">
                <p
                    class="cont-intro"
                    [innerHtml]="
                        'adminUpdateOrg.emergencyContactDesc1' | translate
                    "
                    translate></p>
                <!-- <h5>Message Preview</h5> -->
                <div *ngIf="contactGroupTelephone" class="emergency-info">
                    <h2>{{ organization.contactGroup.title }}</h2>
                    <p
                        [translate]="
                            organization?.contactGroup?.description
                                ? organization.contactGroup.description
                                : 'contact.profesionals'
                        "></p>
                    <button
                        class="app-c-btn app-c-btn--secondary"
                        (keypress)="
                            onCallContact($event, organization.contactGroup)
                        "
                        (click)="
                            onCallContact($event, organization.contactGroup)
                        "
                        translate>
                        contact.getHelpNow
                    </button>
                    <div class="emergency-contact-footer emergency-main">
                        <span *ngIf="contactGroupTelephone"
                            ><span translate> adminUpdateOrg.call</span>
                            :<abbr>{{ contactGroupTelephone }}</abbr></span
                        >
                        <span *ngIf="contactGroupTextMsgNumber"
                            ><span translate> adminUpdateOrg.text</span>
                            :<abbr>{{ contactGroupTextMsgNumber }}</abbr></span
                        >
                    </div>
                </div>

                <div *ngIf="emergencyContact" class="emergency-info">
                    <h2 translate>contact.need</h2>
                    <div [innerHTML]="emergencyContact"></div>
                </div>

                <div *ngIf="showOther" class="emergency-info">
                    <h2 translate>contact.need</h2>
                    <p translate>contact.profesionals</p>
                    <button
                        class="app-c-btn app-c-btn--secondary"
                        (click)="onHotline($event)"
                        (keypress)="onHotline($event)"
                        translate>
                        contact.getHelpNow
                    </button>
                    <div class="emergency-contact-footer emergency-main">
                        <span>
                            <span translate> adminUpdateOrg.call</span>
                            :<abbr>{{ hotline.title }}</abbr></span
                        >
                    </div>
                </div>
            </div>
            <div class="rm-info">
                <div>
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16.0003 29.3334C23.3337 29.3334 29.3337 23.3334 29.3337 16.0001C29.3337 8.66675 23.3337 2.66675 16.0003 2.66675C8.66699 2.66675 2.66699 8.66675 2.66699 16.0001C2.66699 23.3334 8.66699 29.3334 16.0003 29.3334Z"
                            stroke="#0F1827"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M16 10.6667V17.3334"
                            stroke="#0F1827"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path
                            d="M15.9922 21.3333H16.0042"
                            stroke="#0F1827"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </div>
                <div>
                    <p
                        [innerHtml]="
                            'adminUpdateOrg.emergencyContactDesc2' | translate
                        "
                        translate></p>
                </div>
            </div>
        </div>
    </div>

    <div class="footer-down">
        <div class="page-section-buttons">
            <a
                *ngIf="isLoaded"
                tabindex="0"
                [ngClass]="{ 'btn-disabled': !isSaved }"
                (click)="onUpdateMain()"
                (keypress)="onUpdateMain()"
                class="btn btn-bold"
                translate>
                adminUpdateOrg.saveOrganization
            </a>
        </div>
    </div>
</div>
